import { cn } from '@/lib/utils';
import { Slot } from '@radix-ui/react-slot';
import type { VariantProps } from 'class-variance-authority';
import type { ComponentPropsWithoutRef, ForwardedRef } from 'react';
import { forwardRef } from 'react';
import { typographyVariants } from './typography-variants';

interface TypographyProps
  extends
    Omit<ComponentPropsWithoutRef<'p'>, keyof VariantProps<typeof typographyVariants>>,
    VariantProps<typeof typographyVariants> {
  asChild?: boolean;
}

const Typography = forwardRef<HTMLParagraphElement, TypographyProps>(
  (
    { className, variant, weight, asChild = false, ...props },
    ref: ForwardedRef<HTMLParagraphElement>
  ) => {
    const Component = asChild ? Slot : 'p';

    const classNames = cn(typographyVariants({ variant, weight, className }));

    return <Component className={classNames} ref={ref} {...props} />;
  }
);

Typography.displayName = 'Typography';

export { Typography };
